const prod = {
  url: 'https://dartmate-backend.herokuapp.com',
};

const dev = {
  url: 'http://localhost:3000',
};

// eslint-disable-next-line import/prefer-default-export
export const config = process.env.NODE_ENV === 'development' ? dev : prod;
